import React from 'react';
import { Checkbox } from '@/components/ui/Checkbox';
import type { FileFilters } from '../../../../../types/file.types';
import { FilterLabel } from './base/FilterLabel';

interface FilterOptionProps {
  id: FileFilters;
  label: string;
  checked: boolean;
  onChange: () => void;
}

export const FilterOption: React.FC<FilterOptionProps> = ({
  id,
  label,
  checked,
  onChange,
}) => {
  return (
    <span className="flex items-center">
      <Checkbox
        size="sm"
        name={id}
        id={id}
        checked={checked}
        onChange={onChange}
      />
      <FilterLabel htmlFor={id}>{label}</FilterLabel>
    </span>
  );
};
